<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <div class="common-form">新增轮播图</div>
      <el-form-item label="排序" prop="sort" :rules="[{required: true,message: ' '}]">
        <el-input type="text" v-model="form.sort" class="max-w460" prop="sort"></el-input>
      </el-form-item>
      <el-form-item label="图片" :rules="[{required: true,message: '选择图片'}]">
        <el-button @click="chooseImg('logo')">选择图片</el-button>
        <div v-if="form.img_id!=''" class="img">
          <img :src="img_file_path" width="100" height="100" />
        </div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit()" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc"></Upload>
  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';
  import Upload from '@/components/file/Upload';

  export default {
    components:{
      Upload
    },
    data() {
      return {
        loading: false,
        /*切换菜单*/
        // activeIndex: '1',
        /*form表单数据*/
        form: {
          img_id:0,
          sort: null
        },
        img_file_path: '',
        type:null,
        isupload:false,
      };
    },
    created() {},

    methods: {
      /*选择图片*/
      chooseImg(e){
        this.type=e;
        this.isupload=true;
      },

      //提交表单
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.addBanner(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，添加成功',
                  type: 'success'
                });
                 self.$router.push('/setting/banner/index');

              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },

      /*关闭选择图片*/
      returnImgsFunc(e){
        if (e != null && e.length > 0) {
          if(this.type == 'logo'){
            this.img_file_path = e[0].file_path;
            this.form.img_id = e[0].file_id;
          }
        }
        this.isupload=false;
      }
    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/banner/add.vue